import * as React from 'react';
import SidebarLayout from "../../../../src/components/SidebarLayout";
import { Header } from 'decentraland-ui/dist/components/Header/Header';
import { Section } from 'decentraland-ui/dist/components/Section/Section';
import SectionCard from "../../../../src/components/SectionCard";
import { SectionCardProps } from "../../../../src/components/UserTypeCard/types";
import featured from "../../../../src/configurable-content/player-highlights.json";
export default {
  React,
  SidebarLayout,
  Header,
  Section,
  SectionCard,
  SectionCardProps,
  featured
};